import decodeHTML from './decodeHTML';
import parseTemplate from './parseTemplate';
import removeTextFollowedByColon from './removeTextFollowedByColon';
import GlobalVariables from '../GlobalVariables';
import { ScriptsQuestionType } from '../enums/Enum';
import logIt from '../../../logIt';
import RunAsSoonAs from './RunAsSoonAs';

/*
 * This is a stand-alone class to cater handling piped messages regardless of the context (i.e. DOM or Prechat)
 * USAGE:
 * 1- just call ApexChat.PipedMessageHandlerSingleton.isValidPipedMessage(msg)
 * 2- and if true call ApexChat.PipedMessageHandlerSingleton.startPolling({optional callbacks to plug custom behavior})
 * EXAMPLE: see onMessageArrived in chatroom-v3.js
 */
const PipedMessageHandler = function (options) {
    const me = this;
    me.isValidPipedMessage = false;
    me.messageInterval = null;
    me._pollPeriodically = function () {
        logIt(`MULTI::polling with delay:${me.interval}`);
        window.clearInterval(me.messageInterval);
        let calcInterval = me.interval;
        // priodically change timeout for each split piped message
        if (me.intervalsArray) {
            for (let i = 0; i < me.multiMessages.length; i++) {
                if (me.intervalsArray[i]) {
                    calcInterval = me.intervalsArray[i];
                }
                console.log(i, me.intervalsArray[i], calcInterval);
            }
        }
        me.messageInterval = setInterval(pollMessages, calcInterval); // start sending messages async
    };

    // Firstly, validate the message as a piped msg; if true, initialize things required for polling later
    const delayEstimator = function (number) {
        if (number <= 30) {
            return 2000;
        }
        if (number <= 50) {
            return 2500;
        }
        if (number <= 75) {
            return 3000;
        }
        if (number <= 100) {
            return 3500;
        }
        return 4000;
    };
    const validateMessage = function (args) {
        ApexChat.isProcessingPipedMessage = true; // turn on

        // m must be a Plain or QT  msg delimitted by || with the last one QT text
        if (args.m.questionType >= ScriptsQuestionType.None &&
            args.m.text.indexOf(GlobalVariables.FULLTEXT_MULTIPLE_MESSAGE_DELIMITER) > 0) {
            me.isValidPipedMessage = true;
            me.args = args;
            me.args.m.text = parseTemplate(
                removeTextFollowedByColon(decodeHTML(me.args.m.text)),
                ApexChat.options || ''
            );
            me.multiMessages = me.args.m.text
                .split(GlobalVariables.FULLTEXT_MULTIPLE_MESSAGE_DELIMITER)
                .reverse();
            me.randomIdSeed = Math.ceil(Math.random() * 100000);

            // Generate differnt timeout for each split pipe message
            me.intervalsArray = [];
            if (me.args.m.isFromHistory || me.args.m.isFromPreChat) {
                me.intervalsArray = undefined;
            } else if (me.multiMessages.length > 1) {
                for (var i = 0; i < me.multiMessages.length; i++) {
                    // remove text before :: to calculate the actual time
                    const leanText = removeTextFollowedByColon(me.multiMessages[i]);
                    if (me.multiMessages[i].length) {
                        // check if pipe message is first then duration to be set from options
                        // check if the length os less than or equal to 100 than
                        // apply the factor or use 4000ms delay by default
                        if (i === me.multiMessages.length - 1) {
                            if (!ApexChat.addDelayToMappedQuestion) {
                                const firstMessageDuration = options &&
                                    options.preChat &&
                                    options.preChat.preChatMessages &&
                                    options.preChat.preChatMessages.length > 0 &&
                                    options.preChat.preChatMessages[0].duration > 0;

                                if (firstMessageDuration) {
                                    me.intervalsArray.push(
                                        options.preChat.preChatMessages[0].duration * 1000
                                    );
                                } else {
                                    me.intervalsArray.push(1000);
                                }
                            } else {
                                me.intervalsArray.push(delayEstimator(+leanText.length));
                            }
                        } else {
                            me.intervalsArray.push(delayEstimator(+leanText.length));
                        }
                    }
                }
            }
            // now check how many msgs should be processed quickly
            // criteria: match me.multiMessages vs ApexChat.prechatMessagesDisplayed
            // get index of last prechat msg clicked and hence calculate _noOfQuickMsgs
            if (ApexChat.prechatMessagesDisplayed) {
                let count = 0;
                // Simple Reverse was disturbing the orignal Array, i used slice().reverse()
                // Source: https://stackoverflow.com/questions/30610523/reverse-array-in-javascript-without-mutating-original-array
                const multiMessages = me.multiMessages.slice().reverse();
                for (var i = 0; i < ApexChat.prechatMessagesDisplayed.length; i++) {
                    var totalPipedMsgArray = ApexChat.prechatMessagesDisplayed[i];
                    multiMessages.find((displayedMsg, i) => {
                        if (totalPipedMsgArray.text === displayedMsg &&
                            totalPipedMsgArray.isShown) {
                            count++;
                        }
                    });
                }
                me._noOfQuickMsgs = count;
                ApexChat.prechatMessagesDisplayed = null; // dispose once used
            }
            return true;
        }
        ApexChat.isProcessingPipedMessage = false;
        logIt('The message is not a pipped one');
        return false;
    };
    // used to stop polling after last msg has been sent over
    function stopPolling() {
        // cleanup previous state just in case, before processing a new msg
        _destroy();
    }
    // used to send split parts of a QT message 1-by-1
    function pollMessages(recur) {
        if (!me.multiMessages || (me.multiMessages && me.multiMessages.length === 0)) {
            // if multiMessage not available
            stopPolling(); // stop polling if its running.
            return;
        }
        logIt(`MULTI::polling messages:${me.multiMessages.length}`);
        if (me.multiMessages.length == 1) {
            // the last one? treat it as a normal QT
            const copyArgs = JSON.parse(JSON.stringify(me.args));
            copyArgs.m.isSplitMessage = true;
            var msg = me.multiMessages.pop(); // pick the last QT msg
            copyArgs.m.text = msg;
            // we already have 3s delay for piped/split messages,
            // so we need to bypass config based questionTypeDelaySeconds
            // to avoid longer delays for a QT in the pipped msg
            if (copyArgs.m.questionType > 0) {
                copyArgs.m.questionTypeDelaySeconds = me.interval;
            }
            copyArgs.m.isLastSplitMessage = true;
            copyArgs.cb = stopPolling; // send stopPolling over to the caller; i.e. onMessageArrived in widgetbase.js
            logIt(`MULTI:: polling last msg:${JSON.stringify(copyArgs)}`);
            me._lastPollingCallback(copyArgs); // pass on to further process; e.g. display the last msg
            return;
        }
        // handle initial texts 1-by-1 as plain msgs
        var msg = me.multiMessages.pop(); // pick next split msg

        // clone m
        const copyMsg = JSON.parse(JSON.stringify(me.args.m));
        copyMsg.createdOn = me.args.m.createdOn;
        copyMsg.questionType = ScriptsQuestionType.None; // treat the initial texts as plain messages
        copyMsg.text = msg;
        copyMsg.id = ++me.randomIdSeed;
        copyMsg.isSplitMessage = true;
        logIt(`MULTI:: polling: ${JSON.stringify(copyMsg)}`);
        me._startPollingCallback(copyMsg).then(() => {
            // process quick msgs and display the rest with delay
            // we need 1 not 0 because the first message will always be seen and already executed, in above code.
            if (recur && me._noOfQuickMsgs > 1 && copyMsg.isFromPreChat) {
                me._noOfQuickMsgs--;
                RunAsSoonAs(() => {
                    pollMessages(recur);
                }, () => { return copyMsg.messagedHandled; })
            } else {
                me._pollPeriodically();
            }
        }); // pass on to further process; e.g. display the msg
    }

    var _destroy = function () {
        me.isValidPipedMessage = false;
        window.clearInterval(me.messageInterval);
        me.args = null;
        me._noOfQuickMsgs = null;
        me.multiMessages = null;
        me.randomIdSeed = null;
        ApexChat.isProcessingPipedMessage = false;
        me._init = null;
        me._startPollingCallback = null;
        me._lastPollingCallback = null;
    };
    const _startPolling = async (options) => {
        // set callbacks
        const _init = options && options.init ? options.init : function () { };
        try {
            _init(); // call any init function if specified by caller
        } catch (ex) {
            logIt(`error occurred:${ex}`);
        }
        // setup start/end of polling behavior
        me._startPollingCallback = options && options.startPollingCallback;
        me._lastPollingCallback = options && options.lastPollingCallback;
        me._beforePollingCallBack = options.beforePollingCallBack;
        me.interval = options.messageDisplayDuration || 3000;
        // if _validateMessage method has calculated any me._noOfQuickMsgs, process them
        if (me._noOfQuickMsgs && me._noOfQuickMsgs > 0) {
            // make sure the number of message is greater than 0
            pollMessages(true);
        } else {
            me._pollPeriodically();
        }
    };
    const _isProcessing = function () {
        return ApexChat.isProcessingPipedMessage;
    };
    const _resetInterval = function (ms) {
        window.clearInterval(me.messageInterval);
        me.interval = ms; // re-start sending messages with new interval

    };
    return {
        isValidPipedMessage: validateMessage,
        startPolling: _startPolling,
        reset: _destroy,
        isProcessing: _isProcessing,
        resetInterval: _resetInterval
    };
};
export default PipedMessageHandler;
